import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import Icon from '@atlaskit/icon';
var CustomGlyph = function CustomGlyph(props) {
  return jsx("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), jsx("path", {
    d: "M14.5 14.5L17.5 17.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "square"
  }), jsx("path", {
    d: "M9.5 14.5L6.5 17.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "square"
  }), jsx("path", {
    d: "M9.5 9.5L6.5 6.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "square"
  }), jsx("path", {
    d: "M14.5 9.5L17.5 6.5",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "square"
  }), jsx("path", {
    d: "M12.0001 16V19",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), jsx("path", {
    d: "M8.00012 12L5.00012 12",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), jsx("path", {
    d: "M12.0001 8.00002L12.0001 4.99999",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }), jsx("path", {
    d: "M16.0002 12L19.0002 12",
    stroke: "currentColor",
    strokeWidth: "1.5"
  }));
};
export var AtlassianIntelligenceLogo = function AtlassianIntelligenceLogo(props) {
  return jsx(Icon, _extends({
    glyph: CustomGlyph,
    primaryColor: "var(--ds-icon-brand, #0C66E4)"
  }, props));
};